import React, { useEffect, useMemo, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress, Button, Drawer, Chip, Box, ListItemText, List, ListItem, Popover, Checkbox, IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store/appStore';
import { STATUS } from '../../../utils/status';
import { getExpert } from '../../../redux/slices/expertSlice/addExpertSlice';
import { useParams } from 'react-router-dom';
import { TableCellHead } from '../../table/tableCell';
import SnackbarNotification from '../../snackbar/snackbarNotification';
import PaginationEntries from '../../pagination/paginationEntries';
import { SearchBar } from '../../inputField/textfield';
import { useStyles } from '../../../assets/styles/listTableStyle';
import Error from '../../error/error';
import AddIcon from '@mui/icons-material/Add'
import debounce from 'lodash.debounce';
import TableRowItem from './inviteExpertRowItem';
import InviteExpertDrawer from './inviteExpertDrawer';
import { bulkTaskerOnboard, getProject, getProjectExperts, setBulkOnboardtatus, setUpdateProjectStatus, updateProject, updateProjectExpert, updateProjectExpertTaskLimit } from '../../../redux/slices/projectSlice/addProjectSlice';
import InviteExpertPagination from './inviteExpertPagination';
import DeboardExpertDrawer from './deboardExpertDrawer';
import DeleteModal from '../../modal/deleteModal';
import DeboardUserModal from '../../modal/deboardUserModal';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';
import MenuIcon from "@mui/icons-material/MoreVert";
import { getReview } from '../../../redux/slices/reviewerSlice';
import InviteEmailsDrawer from '../../expertList/inviteEmailsDrawer';
import ArrowButton from '../../ArrowButton/arrowButton';
import { SelectedId, setIds } from '../../../redux/reducers/taskIdSlice';
import MaxTaskAllocateModal from './MaxTaskAllocateModal';
import DisableModal from '../../modal/disableModal';
import { constants } from '../../../constants/env';

const InviteExpertTable = ({ alignment }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch<AppDispatch>();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    "success" | "error" | "info" | "warning"
  >("success");
  const [inviteModalOpen, setInviteModalOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [type, setType] = useState("");
  const getStatus = useSelector(
    (state: RootState) => state.reviewStage.getReviewStatus
  );
  const getReviewStages = useSelector(
    (state: RootState) => state.reviewStage.reviewer
  );
  const updateInviteExpertStatus = useSelector(
    (state: RootState) => state.projects.updateStatus
  );
  const updateProjectMessage = useSelector(
    (state: RootState) => state.projects.updateProjectMessage
  );
  const updateProjectFailMessage = useSelector(
    (state: RootState) => state.projects.updateProjectFailMessage
  );
  const { id } = useParams();
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const { getProjectExpertsStatus, projectExperts } = useSelector(
    (state: RootState) => state.projects
  );
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [adminId, setAdminId] = useState("");
  const [expertType, setExpertType] = useState("TASK");
  const [isBumpedUpByAdmin, setIsBumpedUpByAdmin] = useState("");
  const [isUnblock, setIsUnblock] = useState("");
  const [isTestPassed, setIsTestPassed] = useState(false);
  const [isPromoteTaskerClick, setIsPromoteTaskerClick] = useState(false);
  const [selectedStage, setSelectedStage] = useState("");
  const [selectedChip, setSelectedChip] = useState<string | null>(null);
  const [inviteEmails, setInviteEmails] = useState("");
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLDivElement>(null);
  const bulkOnboardStatus = useSelector((state: RootState) => state.projects.bulkTaskerOnboardStatus);
  const bulkOnboardMessage = useSelector((state: RootState) => state.projects.bulkTaskerOnboardMessage);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [maxTask, setMaxTask] = useState('');
  const [editableTaskLimitIds, setEditableTaskLimitIds] = useState<string[]>([]);
  const [showDisableModal, setShowDisableModal] = useState(false);
  const [userToDisable, setUserToDisable] = useState<any>(null);
  const [selectedValue, setSelectedValue] = useState('email');
  const [gigSource, setGigSource] = useState('');
  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => {
    setIsModalOpen(false);
  }
  const [selectedCategory, setSelectedCategory] = useState<string[]>([]);
  const selectedIds = useSelector((state: RootState) => state.tasks.selectedIds);
  const allIds = (projectExperts.results || []).map((row: { id: any; task_name: any; }) => ({}));
  const fetchedProject = useSelector((state: RootState) => state.projects.projects);
  const fetchedDate = fetchedProject?.created_at;
  const isValid = new Date(fetchedDate) >= new Date("2026-01-13T00:00:00Z");


  const handleAllocate = async (value: number) => {
    const selectedIdsOnly = selectedIds.map((item) => item.id);
    setEditableTaskLimitIds(selectedIdsOnly);

    const payload = {
      project_id: id,
      stage_id: selectedStage,
      experts: selectedIds.map((selectedId: SelectedId) => selectedId.id),
      fields_to_update: {
        task_limit: maxTask ? parseInt(maxTask) : undefined
      }
    };

    try {
      await dispatch(updateProjectExpertTaskLimit(payload)).unwrap();
      dispatch(getProjectExperts({
        project_id: id,
        type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
        page: currentPage,
        paginate: true,
        search: searchTerm,
        pageSize: itemsPerPage,
        stage_id: selectedStage,
        fields: JSON.stringify(['id', 'expert.id', 'expert.first_name', 'is_blocked', 'expert.last_name', 'expert.email', 'expert.pseudo_name', 'created_at', 'type', 'to_be_type', 'review_stage.name', 'task_limit', 'expert.user_name', 'role_id', 'role.name', 'stage_id']),
      }));

      handleSnackbar("Task limit updated successfully", "success");
      setMaxTask('')
      handleCloseModal();
    } catch (error) {
      handleSnackbar("Failed to update task limit", "error");
    }
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentPage(1);
    setSearchTerm(event.target.value.trim());
  };

  const debouncedResults = useMemo(() => {
    return debounce(handleSearchChange, 300);
  }, []);

  useEffect(() => {
    return () => {
      debouncedResults.cancel();
    };
  });

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbar = (
    message: string,
    severity: "success" | "error" | "info" | "warning"
  ) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handleChangeRowsPerPage = (value: number) => {
    setItemsPerPage(value);
    setCurrentPage(1);
  };


  const handleOnChange = (value: number) => {
    setItemsPerPage(value);
  };

  const headers = ["NAME", "EMAIL", "GIG SOURCE ID", "ROLE", "TASK LIMIT", "ASSOCIATION TYPE", "ACTIONS"];

  const handleDeleteClick = (userId: string, userType: string, stage_id: any) => {
    setSelectedChip(stage_id)
    setAdminId(userId);
    setExpertType(userType);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (selectedStage && selectedChip !== selectedStage) {
      setSelectedChip(selectedStage);
    }
  }, [selectedStage]);

  const handleToggleDisable = (row: any) => {
    setUserToDisable(row);
    setShowDisableModal(true);
  };

  const handleDisableClick = () => {
    if (userToDisable) {
      try {
        dispatch(updateProject({
          [userToDisable.is_blocked ? 'enabled' : 'disabled']: {
            [alignment === 'tasker' ? 'taskers' : 'reviewers']: [userToDisable.expert_id],
            stage_id: selectedStage,
          },
          id: id,
        }));
        dispatch(
          getProjectExperts({
            project_id: id,
            type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
            page: currentPage,
            paginate: true,
            search: searchTerm,
            pageSize: itemsPerPage,
            stage_id: selectedStage,
            fields: JSON.stringify(['id', 'expert.id', 'role.name', 'is_blocked', 'expert.first_name', 'expert.last_name', 'expert.user_name', 'task_limit', 'stage_id', 'role_id', 'expert.email', 'expert.pseudo_name', 'created_at', 'type', 'to_be_type', 'review_stage.name', 'is_qualified']),
          })
        );
        setShowDisableModal(false);
      } catch (error) {
        console.error('Failed to update user status', error);
      }
    }
    setUserToDisable(null);
  }

  const handleDisableCancel = () => {
    setShowDisableModal(false);
    setUserToDisable(null);
  };

  const handleBumpedUpClick = (userId: string) => {
    setShowDeleteModal(true);
    setIsPromoteTaskerClick(true);
    setIsBumpedUpByAdmin(userId);
    setIsTestPassed(true);
  };

  const cancelDelete = () => {
    setShowDeleteModal(false);
    setIsPromoteTaskerClick(false);
    setIsBumpedUpByAdmin("");
  };

  const confirmDelete = async () => {
    if (isBumpedUpByAdmin) {
      dispatch(updateProjectExpert({ is_bumped_up_by_admin: isPromoteTaskerClick, is_test_passed: isTestPassed, project_id: id, expert_id: isBumpedUpByAdmin, stage_id: selectedStage }));
      dispatch(getProjectExperts({
        project_id: id,
        type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
        page: currentPage,
        paginate: true,
        search: searchTerm,
        pageSize: itemsPerPage,
        stage_id: selectedStage,
        fields: JSON.stringify(['id', 'expert.id', 'is_blocked', 'expert.user_name', 'role.name', 'expert.first_name', 'expert.last_name', 'user_name', 'task_limit', 'role_id', 'expert.email', 'expert.pseudo_name', 'created_at', 'type', 'to_be_type', 'stage_id', 'review_stage.name', 'is_qualified']),
      }))
      handleSnackbar('Expert Promoted Successfully.', 'success');
      setIsBumpedUpByAdmin("")
      setShowDeleteModal(false)
    } else {
      setShowDeleteModal(false);
      const updatedSelectedIds = selectedIds.filter(
        (selectedId) => selectedId.id !== adminId
      );
      dispatch(setIds(updatedSelectedIds));
      dispatch(updateProject({
        unassign: {
          [alignment === 'tasker' ? 'taskers' : 'reviewers']: [adminId],
          stage_id: selectedStage
        }, id: id
      }));
    }
  };

  const handleInviteClick = (type: string) => {
    setType(type);
    setInviteModalOpen(true);
  };

  const handleChipClick = (clickedChipId: string) => {
    setSelectedChip(clickedChipId);
    setSelectedStage(clickedChipId);
  };

  useEffect(() => {
    if (!selectedStage) return;

    dispatch(
      getProjectExperts({
        project_id: id,
        type: alignment === "tasker" ? "TASK" : "REVIEW",
        page: currentPage,
        paginate: true,
        search: searchTerm,
        pageSize: itemsPerPage,
        stage_id: selectedStage,
        fields: JSON.stringify([
          "id",
          "expert.id",
          "expert.first_name",
          "expert.last_name",
          "expert.user_name",
          "task_limit",
          "role_id",
          "role.name",
          "expert.email",
          "expert.pseudo_name",
          "created_at",
          "is_blocked",
          "type",
          "to_be_type",
          "stage_id",
          "review_stage.name",
          "is_qualified",
        ]),
      })
    );
  }, [
    currentPage, searchTerm, itemsPerPage, selectedStage, alignment, dispatch, id]);

  useEffect(() => {
    dispatch(getReview({ project_id: id || '', category: alignment === 'tasker' ? 'TASK' : 'REVIEW' }));
  }, [dispatch, id, alignment]);
  useEffect(() => {
    if (updateInviteExpertStatus === STATUS.SUCESS) {
      handleSnackbar(
        updateProjectFailMessage !== ""
          ? updateProjectFailMessage
          : updateProjectMessage,
        updateProjectFailMessage !== "" ? "error" : "success"
      );
      setInviteModalOpen(false);
      dispatch(getProjectExperts({
        project_id: id,
        type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
        page: currentPage,
        paginate: true,
        search: searchTerm,
        pageSize: itemsPerPage,
        stage_id: selectedStage,
        fields: JSON.stringify(['id', 'expert.id', 'expert.first_name', 'role.name', 'is_blocked', 'expert_user_name', 'stage_id', 'task_limit', 'role_id', 'expert.last_name', 'expert.email', 'expert.pseudo_name', 'created_at', 'type', 'to_be_type', 'review_stage.name', 'is_qualified']),
      }))
    }
    if (updateInviteExpertStatus === STATUS.FAILED) {
      handleSnackbar(updateProjectMessage, "error");
    }

    if (
      updateInviteExpertStatus === STATUS.SUCESS ||
      updateInviteExpertStatus === STATUS.FAILED
    ) {
      dispatch(setUpdateProjectStatus(STATUS.NOT_STARTED));
    }
  }, [updateInviteExpertStatus, selectedStage, currentPage, itemsPerPage, searchTerm, alignment, dispatch, id, updateProjectMessage, updateProjectFailMessage]);

  useEffect(() => {
    setCurrentPage(1);
    setSearchTerm("");
    setItemsPerPage(10);
    if (getStatus === STATUS.SUCESS) {
      dispatch(getProjectExperts({
        project_id: id,
        type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
        page: 1,
        paginate: true,
        search: '',
        pageSize: itemsPerPage,
        ...(selectedStage && { stage_id: selectedStage }),
        fields: JSON.stringify([
          'id', 'expert.id', 'expert.first_name', 'expert.last_name',
          'expert.user_name', 'task_limit', 'role_id', 'role.name',
          'expert.email', 'expert.pseudo_name', 'created_at', 'is_blocked',
          'type', 'to_be_type', 'stage_id', 'review_stage.name', 'is_qualified', "tasker_qualified_review_stages_list"
        ]),
      }));
    }
  }, [alignment, selectedStage, getStatus, dispatch, id]);

  const handleBulkClick = () => {
    setBulkModalOpen(true);
  };

  const totalPages = Math.ceil((projectExperts.count || 0) / itemsPerPage);

  useEffect(() => {
    if (getReviewStages.results && getReviewStages.results.length > 0) {
      const firstStage = getReviewStages.results[0];
      setSelectedChip(firstStage.id);
      setSelectedStage(firstStage.id);
    }
  }, [getReviewStages]);

  const validateEmails = (emails: string) => {
    const emailArray = emails.split(",").map((email) => email.trim());
    const validEmailRegex =
      /^(?!.*\.\.)(?!.*\.$)(?!^\.)[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalidEmails = emailArray.filter(
      (email) => !validEmailRegex.test(email)
    );
    if (invalidEmails.length > 0 && selectedValue === 'email') {
      return `Invalid emails ${invalidEmails.join(", ")}`;
    }

    const duplicateEmails = emailArray.filter(
      (email, index) => emailArray.indexOf(email) !== index
    );
    if (duplicateEmails.length > 0) {
      return `Duplicate emails: ${duplicateEmails.join(", ")}`;
    }

    return null;
  };
  const [taskLimit, setTaskLimit] = useState("");
  const [selectedOption, setSelectedOption] = useState('');
  const handleAddAllClick = () => {
    const errorMessage = validateEmails(inviteEmails);
    if (errorMessage) {
      handleSnackbar(errorMessage, "error");
      return;
    }
    // if (type === 'reviewer' && (stageId === undefined || stageId === null)) {
    //   handleSnackbar("Please select stage", "error");
    //   return;
    // }
    const payload = {
      project_id: id,
      // emails: selectedValue === 'email' ? inviteEmails : gigSource,
      emails: inviteEmails,
      type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
      stage_id: selectedOption,
      task_limit: taskLimit ? parseInt(taskLimit) : undefined,
      role_id: selectedCategory
    };
    dispatch(bulkTaskerOnboard(payload))
      .then(() => {
        setInviteEmails("");
        setTaskLimit('');
        setSelectedCategory([]);
        setInviteModalOpen(false);
        // handleSnackbar("Invitations sent successfully", "success");
      })
      .catch(() => {
        // handleSnackbar(createMultipleExpertMessage, "error");
      });
  };

  useEffect(() => {
    if (selectedStage) {
      setSelectedOption(selectedStage);
    }
  }, [selectedStage]);

  useEffect(() => {
    if (bulkOnboardStatus === STATUS.SUCESS) {
      setBulkModalOpen(false)
      dispatch(getProjectExperts({
        project_id: id,
        type: alignment === 'tasker' ? 'TASK' : 'REVIEW',
        page: 1,
        paginate: true,
        search: '',
        pageSize: itemsPerPage,
        stage_id: selectedStage,
        fields: JSON.stringify([
          'id', 'expert.id', 'expert.first_name', 'expert.last_name',
          'expert.user_name', 'task_limit', 'role_id', 'role.name',
          'expert.email', 'expert.pseudo_name', 'created_at',
          'type', 'to_be_type', 'stage_id', 'review_stage.name', 'is_blocked', 'is_qualified'
        ]),
      }));
      handleSnackbar(bulkOnboardMessage, 'success');
    }
    if (bulkOnboardStatus === STATUS.FAILED) {
      handleSnackbar(bulkOnboardMessage, 'error');
    }
    return () => {
      if (
        bulkOnboardStatus === STATUS.SUCESS ||
        bulkOnboardStatus === STATUS.FAILED
      ) {
        dispatch(setBulkOnboardtatus(STATUS.NOT_STARTED));
      }
    };
  }, [bulkOnboardStatus, dispatch]);

  const handleMenuItemClick = () => {
    handleInviteClick('onboard');
    setAnchorEl(null);
  };

  const handleMenuClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const [anchorE, setAnchorE] = useState<null | HTMLElement>(null);
  const handleSelectAllClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorE(event.currentTarget);
  };

  const currentPageTasks = projectExperts.results || [];
  const currentSelectedIds = selectedIds.filter((selectedId) =>
    currentPageTasks.some((task: any) => task.expert_id === selectedId.id)
  );

  const allSelected =
    currentPageTasks.length > 0 &&
    currentPageTasks.every((row: any) => selectedIds.some((id) => id.id === row.expert_id));

  const handleClosePopover = () => {
    setAnchorE(null);
  };

  const guard: any = () => {
    handleSnackbar("Create stages first before onboarding/deboarding users.", "error")
    return;
  }

  const handleDoneClick = () => {
    const isAllSelectedOnPage = currentPageTasks.every((task: any) =>
      selectedIds.some((selectedId) => selectedId.id === task.expert_id)
    );
    if (isAllSelectedOnPage) {
      const newSelectedIds = selectedIds.filter(
        (selectedId) =>
          !currentPageTasks.some((task: any) => task.expert_id === selectedId.id)
      );
      dispatch(setIds(newSelectedIds));
    } else {
      const newSelectedIds = [
        ...selectedIds,
        ...currentPageTasks
          .filter(
            (task: any) =>
              !selectedIds.some((selectedId) => selectedId.id === task.expert_id)
          )
          .map((task: any) => ({ id: task.expert_id, task_name: task.task_name })),
      ];
      dispatch(setIds(newSelectedIds));
    }

    handleClosePopover();
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={bulkModalOpen}
        onClose={() => { setBulkModalOpen(false) }
        }
        sx={{
          "& .MuiDrawer-paper": {
            width: "40%",
            padding: "40px",
          },
        }}
      >
        <InviteEmailsDrawer handleAddAllClick={handleAddAllClick} inviteEmails={inviteEmails} setSelectedCategory={setSelectedCategory} selectedCategory={selectedCategory} setGigSource={setGigSource} gigSource={gigSource} selectedValue={selectedValue} setSelectedValue={setSelectedValue} setInviteEmails={setInviteEmails} handleClose={() => setBulkModalOpen(false)} selectedStage={selectedStage} taskLimit={taskLimit} setTaskLimit={setTaskLimit} setSelectedOption={setSelectedOption} selectedOption={selectedOption} />
      </Drawer>
      <div className={classes.container}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {/* <div style={{ marginLeft: "0px" }}>
            <SearchBar onSearchChange={debouncedResults} />
          </div> */}
          <div style={{ marginLeft: "0px" }}>
            <SearchBar onSearchChange={debouncedResults} />
          </div>
        </div>

        <div className={classes.actionsContainer}>
          <PaginationEntries itemsPerPage={itemsPerPage} onChangeRowsPerPage={handleChangeRowsPerPage} handleOnChange={handleOnChange} />
          {/* {(constants.CREATE_PROJECT_FEATURE || isValid) && */}
          {/* {(constants.CREATE_PROJECT_FEATURE || isValid) && */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                disableElevation
                onClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleBulkClick}
                sx={{
                  width: 'auto',
                  height: '40px',
                  marginTop: '10px',
                  borderRadius: '8 0 0 8',
                  padding: '8px, 16px, 8px, 16px',
                  backgroundColor: '#3D85C6',
                  textTransform: 'none',
                  marginLeft: '10px',
                  '&:hover': {
                    backgroundColor: '#3D85C6',
                  },
                }}
              >
                <AddIcon fontSize="small" sx={{ marginRight: "10px" }} /> Bulk
                Onboard
              </Button>
              <ArrowButton
                handleMenuClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleMenuClick}
                anchorEl={anchorEl}
                handleMenuClose={handleMenuClose}
                handleAddClick={(getReviewStages?.count ?? 0) <= 0 ? guard : handleMenuItemClick}
                menuText={"Onboard"}
                guard={guard}
              />
            </div>
          {/* } */}

          {/* {(constants.CREATE_PROJECT_FEATURE || isValid) && */}
            <Button
              variant="contained"
              disableElevation
              onClick={() => (getReviewStages?.count ?? 0) <= 0 ? guard : handleInviteClick('deboard')}
              sx={{
                width: 'auto',
                height: '40px',
                marginTop: '20px',
                borderRadius: '8px',
                padding: '8px, 16px, 8px, 16px',
                backgroundColor: '#C00F00',
                textTransform: 'none',
                marginLeft: '10px',
                '&:hover': {
                  backgroundColor: '#C00F00',
                },
              }}>
              <PersonRemoveAlt1Icon fontSize='small' sx={{ marginRight: '10px' }} /> Deboard
            </Button>
          {/* } */}
        </div>
      </div>

      <div style={{ marginTop: "-15px", marginBottom: "5px" }}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start" flexWrap="wrap">
          <Box display="flex" flexWrap="wrap" gap={1} flexGrow={1}>
            {getStatus === STATUS.SUCESS && getReviewStages?.results?.length > 0 &&
              getReviewStages?.results?.map((option: any) => (
                <Chip
                  key={option.id}
                  label={option.name}
                  sx={{
                    backgroundColor: selectedChip === option.id ? '#1976d2' : 'default',
                    color: selectedChip === option.id ? 'white' : 'default',
                    '&:hover': {
                      backgroundColor: selectedChip === option.id ? '#1565c0' : '#e0e0e0',
                    },
                  }}
                  onClick={() => handleChipClick(option.id)}
                />
              ))}
          </Box>

          <Tooltip title={selectedIds.length === 0 ? "Select IDs to enable" : ""}>
            <span>
              <IconButton onClick={handleOpenModal} disabled={selectedIds.length === 0}>
                <MenuIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </div>

      <Drawer
        anchor="right"
        open={inviteModalOpen}
        onClose={() => setInviteModalOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: "50%",
            padding: "40px",
          },
        }}
      >
        {type === 'onboard' ? <InviteExpertDrawer handleClose={() => setInviteModalOpen(false)} alignment={alignment} selectedStage={selectedStage} /> : <DeboardExpertDrawer handleClose={() => setInviteModalOpen(false)} alignment={alignment} selectedStage={selectedStage} />}

      </Drawer>

      <TableContainer style={{ minHeight: "75px" }}>
        {getProjectExpertsStatus === STATUS.PENDING && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CircularProgress />
          </div>
        )}
        {getProjectExpertsStatus === STATUS.SUCESS && (
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead
              sx={{
                backgroundColor: "#F7F9FA",
                "&:first-child td, &:first-child th": { borderBottom: 0 },
              }}
            >
              <TableRow>
                <TableCellHead>
                  <Checkbox
                    checked={allSelected}
                    onClick={handleSelectAllClick}
                    size="small"
                  />
                  <Popover
                    open={Boolean(anchorE)}
                    anchorEl={anchorE}
                    onClose={handleClosePopover}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "left",
                    }}
                  >
                    <div>
                      <List>
                        <ListItem
                          selected={allIds.length === selectedIds.length}
                          onClick={() => handleDoneClick()}
                          sx={{ cursor: "pointer" }}
                        >
                          <ListItemText
                            primary={`${currentSelectedIds.length ===
                              currentPageTasks.length
                              ? "Deselect"
                              : "Select"
                              } ${currentPageTasks.length} users`}
                          />
                        </ListItem>
                      </List>
                    </div>
                  </Popover>
                </TableCellHead>
                {headers.map((header) => (
                  <TableCellHead key={header}>{header}</TableCellHead>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {getProjectExpertsStatus === STATUS.SUCESS &&
                projectExperts &&
                projectExperts.results &&
                projectExperts.results.length > 0 ? (
                projectExperts.results.map((row: any) => (
                  <TableRowItem
                    key={row.id}
                    row={row}
                    onDeleteClick={handleDeleteClick}
                    onToggleDisable={handleToggleDisable}
                    editable={editableTaskLimitIds.includes(row.id)}
                    onBumpedUpClick={handleBumpedUpClick}
                    alignment={alignment}
                    selectedStage={selectedStage}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noUsersMessage}>
                    <Error
                      message={
                        "There are no experts added as of yet. You can add a expert to see it here."
                      }
                    />
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <InviteExpertPagination
        currentPage={currentPage}
        totalPages={totalPages}
        paginate={paginate}
        itemsPerPage={itemsPerPage}
      />
      {(isBumpedUpByAdmin || isUnblock) ? (
        <DeleteModal
          open={showDeleteModal}
          onCancel={cancelDelete}
          onConfirm={confirmDelete}
          deleteText={isBumpedUpByAdmin ? "Promote" : "Unblock"}
          isButtonLoading={updateInviteExpertStatus === STATUS.PENDING}
        />
      ) : (
        <DeboardUserModal
          open={showDeleteModal}
          onCancel={cancelDelete}
          onConfirm={confirmDelete}
          isButtonLoading={updateInviteExpertStatus === STATUS.PENDING}
        />
      )}
      <DisableModal
        open={showDisableModal}
        onCancel={handleDisableCancel}
        onConfirm={handleDisableClick}
        isDisabled={userToDisable ? userToDisable.is_blocked : false}
        ModalName={alignment === 'tasker' ? 'Tasker' : 'Reviewer'}
      />
      <MaxTaskAllocateModal
        open={isModalOpen}
        onClose={handleCloseModal}
        onAllocate={handleAllocate}
        maxTask={maxTask}
        setMaxTask={setMaxTask}
      />
      <SnackbarNotification
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default InviteExpertTable;
